"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedFooter = void 0;
const react_1 = __importDefault(require("react"));
const images_1 = require("./images");
const hooks_1 = require("./hooks");
const shared_footer_styles_1 = __importStar(require("./shared-footer.styles"));
const SharedFooter = ({ className, provider, onExit, date, formatter, forcedTheme, customLogo }) => {
    const { Watermark, themeAccent } = (0, hooks_1.useWatermark)(provider, forcedTheme, customLogo);
    const updatedAt = (0, hooks_1.useFormatter)(date, formatter);
    const onExitHd = () => {
        if (onExit)
            onExit();
    };
    return (react_1.default.createElement(shared_footer_styles_1.default, { className: className, "$withExit": Boolean(onExit) },
        react_1.default.createElement(shared_footer_styles_1.AsOfWrap, null, updatedAt),
        react_1.default.createElement(Watermark, { themeAccent: themeAccent }),
        onExit && react_1.default.createElement(shared_footer_styles_1.ExitButton, { variant: "transparent", onClick: onExitHd, EndIcon: react_1.default.createElement(images_1.ExitLogo, null) })));
};
exports.SharedFooter = SharedFooter;
